import _slicedToArray from "/home/viktor/dev/Regina/regina/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/viktor/dev/Regina/regina/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.from-entries.js";
import { isArray, isObject } from "@chakra-ui/utils";
export function walkObject(target, predicate) {
  function inner(value, path) {
    if (path === void 0) {
      path = [];
    }

    if (isArray(value)) {
      return value.map(function (item, index) {
        return inner(item, [].concat(_toConsumableArray(path), [String(index)]));
      });
    }

    if (isObject(value)) {
      return Object.fromEntries(Object.entries(value).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            child = _ref2[1];

        return [key, inner(child, [].concat(_toConsumableArray(path), [key]))];
      }));
    }

    return predicate(value, path);
  }

  return inner(target);
}